<template>
  <ReservationWalkIn
    @reservationCreated="goToReservationDetailPage"
    @cancel="goToReservationListPage"
  />
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'

import { PERFORMANCE_ROUTE_NAMES } from '@/modules/performance/constants/PerformanceRouteConstants'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import ReservationWalkIn from '@/modules/reservation/pages/ReservationWalkIn.vue'

import { ReservationId } from '@generated/types'

const router = useRouter()
const performanceReservationStore = usePerformanceReservationStore()

async function goToReservationDetailPage(reservationId: ReservationId) {
  await router.replace({
    name: PERFORMANCE_ROUTE_NAMES.RESERVATION_DETAIL,
    params: { reservationId },
  })
}

async function goToReservationListPage() {
  performanceReservationStore.setSelectedTableIds([])
  await router.push({
    name: PERFORMANCE_ROUTE_NAMES.RESERVATION_LIST,
  })
}
</script>
